import { useQuery } from "@tanstack/react-query";
import { PaginationInterfaceSend } from "interfaces/pagination.interface";
import QueryGlobalInterface from "interfaces/queryInterface";
import { toast } from "react-toastify";
import instance from "services/axiosServices";

export interface ProductsFilterInterface {
  PalavrasChave?: string;
  filtersQuery: string;
}

export function useListarProdutosV1(
  props: QueryGlobalInterface &
    ProductsFilterInterface &
    PaginationInterfaceSend
) {
  const fetchData = async () => {
    const PRODUTOS = `/locais/mobile/produtos/v1?PalavrasChave=${props.PalavrasChave}&PaginaAtual=${props.PaginaAtual}&TotalItensRetorno=${props.TotalItensRetorno}${props.filtersQuery}`;
    const response = await instance.get(PRODUTOS);
    const dataWithPagination = {
      data: response?.data?.data,
      pagination: response?.data?.pagination,
    };
    return dataWithPagination;
  };
  const query = useQuery({
    queryFn: () => fetchData(),
    queryKey: [props.queryKey],
    refetchOnWindowFocus: false,
    enabled: true,
    retry: false,
    onError: (error: any) => {
      toast?.error(
        `Erro ao listar produtos. Motivos:\n ${error.response.data.notifications?.map(
          (item: any) => `${item?.message}`
        )} `,
        { autoClose: 10000 }
      );
    },
  });
  return query;
}
